import { Box, Divider, List, Typography } from "@mui/material"
import type { FC, ReactNode } from "react"
import React from "react"
import { Trans } from "react-i18next"
import MenuOffersFilter from "../features/offers/components/MenuOffersFilter"
import type { Offer } from "../features/offersList/offersListTypes"
import type { FilterState, Option } from "../hooks/useOffersFilter"
import Card from "./Card"

interface OffersSidebarProps {
  offers: Offer[]
  categories: Option[]
  programs: Option[]
  tags: Option[]
  onFilterChange: (filters: FilterState) => void
  renderOfferItem: (offer: Offer, index: number) => ReactNode
  emptyMessage?: string
}

const OffersSidebar: FC<OffersSidebarProps> = ({
  offers,
  categories,
  programs,
  tags,
  onFilterChange,
  renderOfferItem,
  emptyMessage = "Nenhuma oferta encontrada correspondendo aos seus critérios.",
}) => {
  return (
    <div className="lg:w-1/3 md:w-1/2 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
      <Card title={<Trans i18nKey="newsletter.sidebar.titleOffers" />}>
        <div className="p-3">
          <MenuOffersFilter
            categoriesOptions={categories}
            programsOptions={programs}
            tagsOptions={tags}
            onFilterChange={onFilterChange}
          />
        </div>

        {/* Scrollable container for the offers list */}
        <Box
          sx={{
            maxHeight: 800, // adjust as needed
            overflowY: "auto",
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <List disablePadding>
            {offers.map((offer, index) => (
              <React.Fragment key={offer.CustomOfferID}>
                {renderOfferItem(offer, index)}
                {index < offers.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}

            {offers.length === 0 && (
              <Box sx={{ textAlign: "center", mt: 4, color: "text.secondary" }}>
                <Typography>{emptyMessage}</Typography>
              </Box>
            )}
          </List>
        </Box>
      </Card>
    </div>
  )
}

export default OffersSidebar